import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FilterValue from './FilterValue';
import Button from '../../common/buttons/Button';
import { applyFilter } from '../../../reduxStore/thunks/index';
import { updateFilter } from '../../../utility/history';
import { breakpointSelector, conversationFacetVOSSelector, selectedFiltersSelector } from '../../../reduxStore/selectors';

type Props = {
  index: number,
  multiSelect?: boolean
};

const ConversationalFilter = ({index, multiSelect}:Props) => {
  const [activeFilters, setActiveFilters] = useState<string[]>([]);
  const breakpoint = useSelector(breakpointSelector)
  const dispatch = useDispatch();
  const conversationFacetVOs = useSelector(conversationFacetVOSSelector);
  const selectedFilters = useSelector(selectedFiltersSelector);
  const onFilterData = useCallback((identifier, values, facetType) => dispatch(applyFilter(identifier, values, facetType, true)), []);

  useEffect(() => {
    if (conversationFacetVOs) {
      const filter = conversationFacetVOs[index];
      if (filter) {
        setActiveFilters(selectedFilters[filter.attrIdentifier] || []);
      }
    }
  }, [selectedFilters]);

  const filter = conversationFacetVOs[index];
  if (!conversationFacetVOs || !filter) {
    return null;
  }
  const filterName = filter.attrName;
  const filterId = filter.attrIdentifier;
  const filterValues = [...filter.valueList]
    .sort((a, b) => {
      if (a.count > b.count) {
        return -1;
      }
      if (a.count < b.count) {
        return 1;
      }
      return 0;
    })
    .filter((el, i) => i < 10);

  const apply = (active: string[], filterType: string) => {
    const values: string[] = [];
    if (active) {
      active.forEach((val) => {
        const existingValues = selectedFilters[filterId];
        if (existingValues && existingValues.indexOf(val) > -1) {
          values.push(`-${val}`);
        } else {
          values.push(val);
        }
      });

      onFilterData(filterId, values, filterType);
      updateFilter(filterId, values, filterType);
    }
  };
  return (
    <div className="in-grid-item dsg-flex">
      <div className="conversational-filter dsg-flex flex-wrap">
        <div className="dsg-flex flex-row">
          <div>
            <p className="sub-title">Popular Filters</p>
            <p className="title">{filterName}</p>
          </div>
          <div className="dsg-flex flex-grow" />
          {multiSelect && activeFilters && activeFilters.length > 0 && breakpoint !== 'mobile' && (
            <div className="dsg-flex flex-grow-none flex-shrink">
              <Button
                variant="secondary"
                label={`Apply Filters (${activeFilters.length})`}
                onClick={() => apply(activeFilters, 'multi')}
                classes={['apply-btn-inline']}
              />
            </div>
          )}
        </div>
        <div className="values dsg-flex flex-row">
          {filterValues.map((value) => {
            return (
              <FilterValue
                key={value.value}
                label={`${value.value} (${value.count})`}
                onClick={() => {
                  if (!multiSelect) {
                    apply([value.value], 'single');
                  } else if (!activeFilters) {
                    setActiveFilters([value.value]);
                  } else if (activeFilters.indexOf(value.value) < 0) {
                    setActiveFilters([...activeFilters, value.value]);
                  } else {
                    setActiveFilters(activeFilters.filter((v) => v !== value.value));
                  }
                }}
              />
            );
          })}
        </div>
        {multiSelect && activeFilters && activeFilters.length > 0 && breakpoint === 'mobile' && (
          <Button
            variant="secondary"
            label={`Apply Filters (${activeFilters.length})`}
            onClick={() => apply(activeFilters, 'multi')}
            classes={['apply-btn']}
          />
        )}
      </div>
    </div>
  );
}

export default ConversationalFilter;
